import I18n from 'I18n';
import PropertyInputV2 from 'customer-data-properties/input/PropertyInputV2';
import { EMPTY_PROPERTY } from 'automation-ui-formula-editor/data-sources/constants/propertyConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const alwaysReturnUndefined = () => undefined;
export default function AddDataSourceMatchingStaticValue({
  dataSourceProperty,
  onChange,
  dataSourcePropertyName,
  value,
  dataSourceObjectTypeId,
  readOnly
}) {
  return /*#__PURE__*/_jsx(PropertyInputV2, {
    disableValidation: true,
    onChange: ({
      [dataSourcePropertyName]: newValue
    }) => {
      onChange(newValue !== null && newValue !== void 0 ? newValue : '');
    },
    value: value,
    readOnly: readOnly || !dataSourceProperty,
    property: dataSourceProperty ? Object.assign({}, dataSourceProperty, {
      // PropertyInputV2 expects to be used to change a property's value regardless of inputMode
      readOnlyValue: false
    }) :
    // PropertyInputV2 requires that a property be provided, even if we haven't selected on yet
    EMPTY_PROPERTY,
    objectTypeId: dataSourceObjectTypeId,
    inputMode: "create",
    getDraftValue: alwaysReturnUndefined,
    getSavedValue: alwaysReturnUndefined,
    inputProps: {
      placeholder: I18n.text('automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.property-matching.property-value-placeholder')
    }
  });
}